let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dIHvK")).then(() => parcelRequire('lS6bs'));